import emailjs from '@emailjs/browser';

import logService from './logService';

const emailService = {
  send: (
    name: string,
    email: string,
    subject: string,
    message: string
  ): Promise<boolean> => {
    emailjs.init(`${process.env.REACT_APP_EMAILJS_PUBLIC_KEY}`);

    const templateParams = { name, email, subject, message };

    return emailjs
      .send(
        `${process.env.REACT_APP_EMAILJS_SERVICE_ID}`,
        `${process.env.REACT_APP_EMAILJS_TEMPLATE_ID}`,
        templateParams
      )
      .then(
        function (response) {
          if (response.status >= 400 && response.status <= 500) {
            return false;
          }

          return true;
        },
        function (err) {
          logService.log(err);
          return false;
        }
      );
  },
};

export default emailService;
